module.exports = __webpack_public_path__ + "static/training1-d002f209e5dd93281a636a8a323db2d4.jpg";